<template>
  <DialogContainer v-model="dialogObj">
    <template v-slot:dialogSlot>
      <div class="role-body custom-form">
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          class="form"
          label-position="top"
        >
          <el-form-item label="类型名称" prop="dictName">
            <el-input
              v-model="form.dictName"
              clearable
              autocomplete="off"
              placeholder="请输入类型名称"
              maxlength="20"
            />
          </el-form-item>
          <el-form-item label="类型编号" prop="dictType">
            <el-input
              v-model="form.dictType"
              clearable
              autocomplete="off"
              placeholder="请输入类型编号"
              maxlength="20"
            />
          </el-form-item>
          <el-form-item label="类型描述" prop="remark">
            <el-input
              v-model="form.remark"
              clearable
              type="textarea"
              :rows="5"
              resize="none"
              autocomplete="off"
              placeholder="请输入类型描述"
              maxlength="100"
            />
          </el-form-item>
        </el-form>
      </div>
    </template>
  </DialogContainer>
</template>

<script>
import DialogContainer from "@/components/Dialog.vue";
import { addInfo, editInfo } from "./api";
export default {
  name: "AddOrEdit",
  components: {
    DialogContainer,
  },
  data() {
    return {
      dialogObj: {
        loading: false,
        btnLoading: false,
        show: false,
        title: "添加角色",
        closeOnClickModal: false,
        confirmFn: this.submitForm,
        beforeClose: (v) => {
          this.form = this.$options.data().form;
          if (this.$refs.form) this.$refs.form.resetFields();
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      form: {
        dictType: "",
        dictName: "",
        remark: "",
        dictTypeId: "",
      },
      rules: {
        dictName: [{ required: true, message: "类型名称不能为空" }],
        dictType: [{ required: true, message: "类型编号不能为空" }],
        remark: "",
      },
    };
  },
  methods: {
    init(row) {
      if (!!row) {
        this.dialogObj.title = "编辑类型";
        this.form = Object.assign({}, row);
      } else {
        this.dialogObj.title = "添加类型";
      }
      this.dialogObj.show = true;
    },
    // 提交数据
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.dialogObj.btnLoading = true;
          let methodName = "";
          if (this.form.dictTypeId) {
            methodName = editInfo;
          } else {
            methodName = addInfo;
          }
          const par = {
            dictType: this.form.dictType,
            dictName: this.form.dictName,
            remark: this.form.remark,
            dictTypeId: this.form.dictTypeId,
          };
          methodName(par)
            .then((res) => {
              this.dialogObj.btnLoading = false;
              if (res.code === 200) {
                this.$message.success(
                  this.form.dictTypeId ? "编辑成功" : "保存成功"
                );
                this.$parent.getTableData();
                this.dialogObj.beforeClose();
              }
            })
            .catch((e) => {
              this.dialogObj.btnLoading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.role-body {
  padding: 0 0.6rem;
  box-sizing: border-box;
}
</style>
